export default {
  Loose: 'desktop',
  Compact: 'desktop/compact',
  Featured: 'desktop/featured',
  Display: 'desktop/display',
  Teleprompter: 'desktop/teleprompter',
  GlobalElement: 'desktop/global',
  Grid: '/grid'
};
